/**
 * Browser clipboard helper (QC shared).
 * Uses the async Clipboard API when available, with a textarea fallback.
 *
 * @param {string} text
 * @returns {Promise<boolean>}
 */
export async function copyTextToClipboard(text) {
  const value = text == null ? '' : String(text);
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    /* fall through to legacy path */
  }
  if (typeof document === 'undefined' || !document.body) return false;
  const ta = document.createElement('textarea');
  try {
    ta.value = value;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    // execCommand is deprecated but still the last-resort fallback.
    const ok = document.execCommand('copy');
    return Boolean(ok);
  } catch {
    return false;
  } finally {
    try {
      if (ta.parentNode) ta.parentNode.removeChild(ta);
    } catch {
      /* ignore detach errors */
    }
  }
}

/**
 * Read plain text from the clipboard (requires secure context + permission where applicable).
 *
 * @returns {Promise<string>}
 */
export async function readTextFromClipboard() {
  try {
    if (navigator.clipboard?.readText) {
      return await navigator.clipboard.readText();
    }
  } catch {
    /* denied or unsupported */
  }
  return '';
}
